<!--  -->
<template>
  <div class="box">
    <canvas style="display:block" v-if="show" :id="conduitInfo.id"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    conduitInfo: {
      type: Object,
    },
    redShow: {
      type: Boolean,
    },
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      show: true,
      mycanvas: null, // canvas节点
      context: null, // canvas实例
      firNUm: 0,
      cursorListNum: [], // 光标的列表
      pointsList: [], // 管道的路径
      pointsListCopy: [], // 每个光标的路径
      // 配置项
      colors: ['#2b6bf1', '#55b1f4'], // 渐变
      canvasWidth: 500, // 宽度
      canvasHeight: 500, // 高度
      step: 2.5, // 运动速度
      space: 60, // 光标的间隔
      curterWidth: 4, // 光标宽度
      curveLineWidth: 12, // 管道宽度
      curterlength: 20, // 光标长度
      pointsCopy: [],
      points: [
        // 整体路径
        {
          // 起始点
          x: 450,
          y: 150,
        },
        {
          // 转折点
          x: 300,
          y: 150,
        },
        {
          // 转折点
          x: 300,
          y: 450,
        },
        {
          // 结束点
          x: 150,
          y: 450,
        },
      ],
      requestId: null,
      LinearGradient: {},
      circle: {
        radius: '', // 管道终点的空心圆半径。
        lineWidth: '', // 空心圆线路宽度
        x: '', // 空心圆x
        y: '', // 空心圆y
      },
      lengthAdd: 0, // 长度累加器
    };
  },
  computed: {},
  watch: {
    'conduitInfo.step': {
      handler() {
        this.stopAn();
        Object.keys(this.conduitInfo).map((item) => {
          this[item] = this.conduitInfo[item]
            ? this.conduitInfo[item]
            : this[item];
        });
        this.points.map((item, index) => {
          item.x = this.setPointProportion(this.pointsCopy[index].x, this.pointsCopy[index].y).x;
          item.y = this.setPointProportion(this.pointsCopy[index].x, this.pointsCopy[index].y).y;
        });
        this.curveLineWidth =  this.setPointProportion(this.curveLineWidth).x;
        this.curterWidth =  this.setPointProportion(this.curterWidth).x;
        this.context.clearRect(0, 0, this.mycanvas.width, this.mycanvas.height); // 清空canvas
        this.pointsListCopy = [];
        this.cursorListNum = [];
        this.pointsList = [];
        if (this.conduitInfo.stop) {
          this.createCurveLineInit();
        } else {
          this.setCanvas();
        }
        // this.setCanvas();
      },
      deep: true,
    },
  },
  // 计算生成光标生成一个list控制光标的开关
  methods: {
    computedCursorList() {
      const lengnth = this.pointsList.length; // 轨迹总长度
      const num =        Math.floor(lengnth / (this.conduitInfo.curterlength + this.conduitInfo.space)) < 0.5
        ? 1
        : Math.floor(lengnth / (this.conduitInfo.curterlength + this.conduitInfo.space)) + 1; // 计算生成多少个光标
      for (let index = 0; index < num; index++) {
        const info = {
          cursorNum: 0,
          flowIsFir: false,
          pointsListCopy: this.getPointListCopy(index),
        };
        this.cursorListNum.push(info);
      }
    },
    // canvas初始化
    setCanvas() {
      this.mycanvas = document.getElementById(this.conduitInfo.id);
      this.context = this.mycanvas.getContext('2d');
      // this.mycanvas.width = this.canvasWidth;
      // this.mycanvas.height = this.canvasHeight;
      this.mycanvas.width = window.innerWidth;
      this.mycanvas.height = window.innerHeight;
      this.pointsList = [this.points[0]];
      this.LinearGradient = {
        x0: 0,
        y0: this.mycanvas.height,
        x1: this.mycanvas.width,
        y1: 0,
      };
      this.computeCurvePoint(); // 获取光标移动的路径
      this.computedCursorList(); // 计算生成光标生成一个list控制光标的开关
      this.$nextTick(() => {
        // this.createCurveLineInit();
        this.draw(); // 启动绘制
      });
    },
    createLinearGradient(context, p0, p1) {
      const gradientCurve = context.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
      return gradientCurve;
    },
    // 绘制背景管道
    createCurveLineInit() {
      let point = [];
      const bgPoint = [];
      this.context.beginPath();
      this.points.map((item, index) => {
        if (index === 0) {
          this.context.moveTo(item.x, item.y);
        }
        this.context.lineTo(item.x, item.y);
        if (item.isStart) {
          point.push(item);
        } else if (!item.isStart && !item.isEnd && point.length > 0) {
          point.push(item);
        }
        if (item.isEnd) {
          if (point.length > 0) {
            point.push(item);
            const curveBg = {
              point,
              // gradientCurve: this.context.createLinearGradient(
              //   point[0].x,
              //   point[0].y,
              //   point[1].x,
              //   point[1].y
              // )
            };
            bgPoint.push(curveBg);
            point = [];
          }
        }
      });
      const line = this.context.createLinearGradient(
        this.conduitInfo.LinearGradient?.x0 || this.LinearGradient.x0,
        this.conduitInfo.LinearGradient?.y0 || this.LinearGradient.y0,
        this.conduitInfo.LinearGradient?.x1 || this.LinearGradient.x1,
        this.conduitInfo.LinearGradient?.y1 || this.LinearGradient.y1
      );
      let colorsLevel = 0;
      for (let i = 0; i < this.conduitInfo.colors.length; i++) {
        line.addColorStop(
          this.conduitInfo.colorsLevel
            ? this.conduitInfo.colorsLevel[i]
            : colorsLevel,
          this.conduitInfo.colors[i]
        );
        colorsLevel += 0.2;
      }
      this.context.lineWidth = this.curveLineWidth;
      this.context.strokeStyle = line;
      this.context.lineJoin = 'round';
      this.context.stroke();
      const bgPointList = {};
      bgPoint.map((item, i) => {
        this.context.beginPath();
        item.point.map((item1, index) => {
          if (index === 0) {
            this.context.moveTo(item1.x, item1.y);
          }
          this.context.lineTo(item1.x, item1.y);
        });

        bgPointList[`Curve${i}`] = this.context.createLinearGradient(
          item.point[0].x,
          item.point[0].y,
          item.point[item.point.length - 1].x,
          item.point[item.point.length - 1].y
        );

        bgPointList[`Curve${i}`].addColorStop(0, item.point[0].color);
        bgPointList[`Curve${i}`].addColorStop(
          1,
          item.point[item.point.length - 1].color
        );
        this.context.strokeStyle = bgPointList[`Curve${i}`];

        this.context.lineWidth = this.curveLineWidth;
        this.context.strokeStyle = item.gradientCurve;
        this.context.lineJoin = 'round';

        this.context.stroke();
      });
      // 终点绘制空心圆
      if (this.conduitInfo.circlePoint) {
        this.circle.x = this.setPointProportion(this.conduitInfo.circlePoint.x, this.conduitInfo.circlePoint.y).x;
        this.circle.y = this.setPointProportion(this.conduitInfo.circlePoint.x, this.conduitInfo.circlePoint.y).y;
        this.drawCircle();
      }
    },
    // 终点绘制空心圆
    drawCircle() {
      const radius = this.circle.radius ? this.circle.radius : this.conduitInfo.circleRadius;
      const lineWidth = this.circle.lineWidth ? this.circle.lineWidth : this.conduitInfo.circleLineWidth;
      const { x, y } = this.circle;
      this.context.beginPath();
      this.context.arc(x, y, radius, 0, 360, false);
      this.context.lineWidth = lineWidth;
      this.context.strokeStyle = this.conduitInfo.circleColor;
      this.context.stroke();// 画空心圆
      this.context.closePath();
    },
    // 创建渐变
    createGradient(context, p0, p1) {
      const gradient = context.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
      gradient.addColorStop(0, `rgba(${this.conduitInfo.shadowColor}, 0)`);
      gradient.addColorStop(
        0.5,
        `rgba(${this.conduitInfo.shadowColor}, ${this.conduitInfo.shadowOpcity})`
      );
      gradient.addColorStop(1, `rgba(${this.conduitInfo.shadowColor}, 1)`);
      return gradient;
    },
    // 绘制光标移动的路径
    createCurveLine(points) {
      const gradient = this.createGradient(
        this.context,
        points[0],
        points[points.length - 1]
      );
      this.context.beginPath();
      this.context.moveTo(points[0].x, points[0].y);
      // 参数 points 是曲线上一部分连续点的集合，我们用 lineTo 把这些点连结起来，就近似的得到了曲线
      for (let i = 0; i < points.length; i++) {
        const p = points[i];
        this.context.lineTo(p.x, p.y);
      }
      this.context.moveTo(points[0].x, points[0].y);
      this.context.strokeStyle = gradient;
      this.context.lineCap = 'round';
      this.context.lineWidth = this.curterWidth;
      this.context.shadowColor = '#fff';
      this.context.shadowBlur = 0;
      this.context.stroke();
      this.context.closePath();
    },
    // setpoint() {
    //   // this.context.clearRect(0, 0, this.mycanvas.width, this.mycanvas.height); // 清空canvas
    //   this.mycanvas.width = window.innerWidth;
    //   this.mycanvas.height = window.innerHeight;
    //   this.createCurveLineInit(); // 绘制管道
    //   this.context.save();
    //   // 绘制第一个光标
    //   // 通过获取光标轨迹的坐标点并且在动画运行的时候不断重新绘制达到光标移动的效果
    //   // let flow1 = this.pointsList.slice(
    //   //   this.firNUm,
    //   //   this.firNUm + this.curterlength
    //   // );
    //   // this.firNUm++;
    //   // this.cursorListNum[0].cursorNum++
    //   // this.cursorListNum[1].cursorNum++
    //   // if (this.firNUm < this.pointsList.length - 1) {
    //   //   this.createCurveLine(flow1);

    //   // } else {
    //   //   this.firNUm = 0;
    //   // }
    //   this.cursorListNum.map((item) => {
    //     item.cursorNum++;
    //   });
    //   //                ----------------------------->
    //   //  3------2------1---------------------------->
    //   //      3------2------1------------------------>
    //   //          3-----2------1--------------------->
    //   //                3------2------1-------------->

    //   // 第二个以后的光标是通过增加移动距离来实现延迟出现的效果所以需在首次绘制需要满足以下条件才开始首次绘制
    //   //      1.光标的计数器<光标轨迹的长度
    //   //      2.光标的计数器>间隔距离x光标数量 && 不是首次绘制 || 是首次绘制
    //   // 如果计数器>轨迹长度的话证明首次绘制结束 就将增加距离后的轨迹恢复为管道的轨迹并且清空计数器, 这样光标就回到原点了
    //   // 绘制剩下的光标
    //   this.cursorListNum.map((item, index) => {
    //     const flow2 = item.pointsListCopy.slice(
    //       item.cursorNum,
    //       item.cursorNum + this.curterlength
    //     );
    //     item.flow2IsFir = item.pointsListCopy.length !== this.pointsList.length; // 判断是否是首次绘制
    //     if (item.cursorNum < item.pointsListCopy.length - 1) {
    //       // if (
    //       //   // (this.space * (index)+(this.curterlength * index))
    //       //   (item.flow2IsFir && item.cursorNum > this.space * (index+1)) ||
    //       //   !item.flow2IsFir
    //       // ) {
    //       //   this.createCurveLine(flow2);
    //       // }
    //       this.createCurveLine(flow2);
    //     } else {
    //       item.cursorNum = 0;
    //       item.pointsListCopy = this.pointsList;
    //     }
    //   });
    //   this.context.restore();

    //   this.requestId = requestAnimationFrame(this.setpoint);
    // },
    // setpoint1() {
    //   // this.context.clearRect(0, 0, this.mycanvas.width, this.mycanvas.height); // 清空canvas
    //   this.mycanvas.width = window.innerWidth;
    //   this.mycanvas.height = window.innerHeight;
    //   this.createCurveLineInit(); // 绘制管道
    //   this.context.save();
    //   // 绘制第一个光标
    //   // 通过获取光标轨迹的坐标点并且在动画运行的时候不断重新绘制达到光标移动的效果
    //   const flow1 = this.pointsList.slice(
    //     this.firNUm,
    //     this.firNUm + this.curterlength
    //   );
    //   this.firNUm++;
    //   this.cursorListNum[0].cursorNum++;
    //   this.cursorListNum[1].cursorNum++;
    //   if (this.firNUm < this.pointsList.length - 1) {
    //     this.createCurveLine(flow1);
    //     this.cursorListNum.map((item) => {
    //       item.cursorNum++;
    //     });
    //   } else {
    //     this.firNUm = 0;
    //   }
    //   //                ----------------------------->
    //   //  3------2------1---------------------------->
    //   //      3------2------1------------------------>
    //   //          3-----2------1--------------------->
    //   //                3------2------1-------------->

    //   // 第二个以后的光标是通过增加移动距离来实现延迟出现的效果所以需在首次绘制需要满足以下条件才开始首次绘制
    //   //      1.光标的计数器<光标轨迹的长度
    //   //      2.光标的计数器>间隔距离x光标数量 && 不是首次绘制 || 是首次绘制
    //   // 如果计数器>轨迹长度的话证明首次绘制结束 就将增加距离后的轨迹恢复为管道的轨迹并且清空计数器, 这样光标就回到原点了

    //   // 绘制剩下的光标
    //   this.cursorListNum.map((item, index) => {
    //     const flow2 = item.pointsListCopy.slice(
    //       item.cursorNum,
    //       item.cursorNum + this.curterlength
    //     );
    //     item.flow2IsFir = item.pointsListCopy.length !== this.pointsList.length; // 判断是否是首次绘制
    //     if (item.cursorNum < item.pointsListCopy.length - 1) {
    //       if (
    //       // (this.space * (index)+(this.curterlength * index))
    //         (item.flow2IsFir && item.cursorNum > this.space * (index + 1))
    //           || !item.flow2IsFir
    //       ) {
    //         this.createCurveLine(flow2);
    //       }
    //     } else {
    //       item.cursorNum = 0;
    //       item.pointsListCopy = this.pointsList;
    //     }
    //   });
    //   this.context.restore();

    //   this.requestId = requestAnimationFrame(this.setpoint);
    // },
    setpoint() {
      this.mycanvas.width = window.innerWidth;
      this.mycanvas.height = window.innerHeight;
      this.createCurveLineInit(); // 绘制管道
      this.context.save();
      //                ----------------------------->
      //  3------2------1---------------------------->
      //      3------2------1------------------------>
      //          3-----2------1--------------------->
      //                3------2------1-------------->

      // 第二个以后的光标是通过增加移动距离来实现延迟出现的效果所以需在首次绘制需要满足以下条件才开始首次绘制
      //      1.光标的计数器<光标轨迹的长度
      //      2.光标的计数器>间隔距离x光标数量 && 不是首次绘制 || 是首次绘制
      // 如果计数器>轨迹长度的话证明首次绘制结束 就将增加距离后的轨迹恢复为管道的轨迹并且清空计数器, 这样光标就回到原点了

      this.cursorListNum.map((item) => {
        item.cursorNum++;
      });
      // 光标长度变化
      if (this.lengthAdd < this.curterlength) {
        this.lengthAdd++;
      }
      // 绘制剩下的光标
      this.cursorListNum.map((item, index) => {
        const flow2 = item.pointsListCopy.slice(
          item.cursorNum,
          item.cursorNum + this.lengthAdd
        );
        item.flow2IsFir = item.pointsListCopy.length !== this.pointsList.length; // 判断是否是首次绘制
        if (item.cursorNum < item.pointsListCopy.length - 1) {
          if (
            (item.flow2IsFir && item.cursorNum > this.space * (index))
              || !item.flow2IsFir
          ) {
            this.createCurveLine(flow2);
          }
        } else {
          item.cursorNum = 0;
          this.lengthAdd = 0;
          item.pointsListCopy = this.pointsList;
        }
      });
      this.context.restore();
      this.requestId = requestAnimationFrame(this.setpoint);
    },
    // 绘制图形
    draw() {
      this.setpoint();
    },
    // start(){
    //   if(this.requestId) {
    //   cancelAnimationFrame(this.requestId)
    //   this.setpoint();
    //   }
    // },
    stopAn() {
      cancelAnimationFrame(this.requestId);
    },
    getPointListCopy(index) {
      // 通过增加距离(光标的间隔)达到光标延时出现的效果
      const arr = [];
      for (let i = 0; i < index * this.space; i++) {
        const p = this.pointsList[0];
        const n = this.pointsList[1];
        if (p.x > n.x && p.y === n.y) {
          // 向左
          arr.push({
            x: p.x + i * this.step,
            y: p.y,
          });
        } else if (p.x < n.x && p.y === n.y) {
          // 向右
          arr.push({
            x: p.x - i * this.step,
            y: p.y,
          });
        } else if (p.y > n.y && p.x === n.x) {
          // 向上
          arr.push({
            x: p.x,
            y: p.y + i * this.step,
          });
        } else if (p.y < n.y && p.x === n.x) {
          // 向下
          arr.push({
            x: p.x,
            y: p.y - i * this.step,
          });
        }
      }
      const newArr = [...arr, ...this.pointsList];
      return newArr;
    },

    // 获取渐变点位集合
    async computeCurvePoint() {
      if (this.pointsList.length > 0) {
        this.points.map((item, index) => {
          if (this.points[index + 1]) this.getPoint(item, this.points[index + 1]);
        });
      }
    },
    /**
     * @description: 根据传入的x坐标，直线两点坐标点，得到y轴坐标。
     * @param {number} {x1, y2, x2, y2} 直线两坐标点
     * @param {number} x 直线上任意坐标点的横坐标x
     * @return {number} y y轴坐标
     * @author: v_hllhe
     */
    getyAxis({ x1, y1, x2, y2 }, x) {
      const res = (x - x1) / (x - x2);
      return (y1 - res * y2) / (1 - res);
    },
    /**
     * @description: 根据传入的直线斜边长度，计算x累加值。
     * @param {number} {x1, y2, x2, y2} 直线两坐标点
     * @param {number} step 斜边累加值
     * @return {number} x累加值
     * @author: v_hllhe
     */
    getxAxis({ x1, y1, x2, y2 }, step) {
      const res = (step * (x2 - x1)) / Math.sqrt(Math.pow((y2 - y1), 2) + Math.pow((x2 - x1), 2));
      return Math.abs(res);
    },
    getPoint(p, n) {
      // 获取光标移动的路径
      const step =  this.setPointProportion(this.step).x;
      const coordinate = this.pointsList[this.pointsList.length - 1];
      if (p.x > n.x && p.y === n.y) {
        // 向左
        if (coordinate.x > n.x) {
          this.pointsList.push({
            x: coordinate.x - step,
            y: n.y,
          });
          this.getPoint(p, n);
        } else if (coordinate.x < n.x) {
          coordinate.x = n.x;
          this.pointsList.push({ x: coordinate.x, y: n.y });
          return;
        }
      } else if (p.x < n.x && p.y === n.y) {
        // 向右
        if (coordinate.x < n.x) {
          this.pointsList.push({
            x: coordinate.x + step,
            y: n.y,
          });
          this.getPoint(p, n);
        } else if (coordinate.x > n.x) {
          coordinate.x = n.x;
          this.pointsList.push({ x: coordinate.x, y: n.y });
          return;
        }
      } else if (p.y > n.y && p.x === n.x) {
        // 向上
        if (coordinate.y > n.y) {
          this.pointsList.push({
            x: coordinate.x,
            y: coordinate.y - step,
          });
          this.getPoint(p, n);
        } else if (coordinate.y < n.y) {
          coordinate.y = n.y;
          this.pointsList.push({ x: coordinate.x, y: coordinate.y });
          return;
        }
      } else if (p.y < n.y && p.x === n.x) {
        // 向下
        if (coordinate.y < n.y) {
          this.pointsList.push({
            x: coordinate.x,
            y: coordinate.y + step,
          });
          this.getPoint(p, n);
        } else if (coordinate.y > n.y) {
          coordinate.y = n.y;
          this.pointsList.push({ x: coordinate.x, y: coordinate.y });
          return;
        }
      } else if (p.y !== n.y && p.x !== n.x) {
        const addX = this.getxAxis({ x1: p.x, y1: p.y, x2: n.x, y2: n.y }, step);
        const x = n.x > p.x ? (coordinate.x + addX) : (coordinate.x - addX);
        const y = this.getyAxis({ x1: p.x, y1: p.y, x2: n.x, y2: n.y }, x);
        if (n.x > p.x) {
        // 斜边 —— 向右方向
          if (x < n.x) {
            this.pointsList.push({
              x,
              y,
            });
            this.getPoint(p, n);
          } else {
            this.pointsList.push({ x: coordinate.x, y: coordinate.y });
            return;
          }
        } else {
        // 斜边 —— 向左方向
          if (x > n.x) {
            this.pointsList.push({
              x,
              y,
            });
            this.getPoint(p, n);
          } else {
            this.pointsList.push({ x: coordinate.x, y: coordinate.y });
            return;
          }
        }
      }
    },
    setPointProportion(x, y) {
      const vwx = (x / 1920) * 100;
      const vwy = (y / 1080) * 100;
      const newx = (vwx / 100) * window.innerWidth;
      const newy = (vwy / 100) * window.innerHeight;
      return { x: newx, y: newy };
    },
  },
  created() {

  },
  mounted() {
    window.addEventListener('resize', () => {
      this.conduitInfo
      && Object.keys(this.conduitInfo).map((item) => {
        this[item] = this.conduitInfo[item]
          ? this.conduitInfo[item]
          : this[item];
      });
      this.curveLineWidth =  this.setPointProportion(this.curveLineWidth).x;
      this.curterWidth =  this.setPointProportion(this.curterWidth).x;
      this.context.clearRect(0, 0, this.mycanvas.width, this.mycanvas.height); // 清空canvas
      this.stopAn();
      this.pointsListCopy = [];
      this.cursorListNum = [];
      this.pointsList = [];
      this.points.map((item, index) => {
        item.x = this.setPointProportion(this.pointsCopy[index].x, this.pointsCopy[index].y).x;
        item.y = this.setPointProportion(this.pointsCopy[index].x, this.pointsCopy[index].y).y;
      });
      if (this.conduitInfo.circlePoint) {
        this.circle.radius = this.setPointProportion(this.conduitInfo.circleRadius).x;
        this.circle.lineWidth = this.setPointProportion(this.conduitInfo.circleLineWidth).x;
        this.circle.x = this.setPointProportion(this.conduitInfo.circlePoint.x).x;
        this.circle.y = this.setPointProportion(this.conduitInfo.circlePoint.y).y;
      }
      this.setCanvas();
    });
    this.conduitInfo
      && Object.keys(this.conduitInfo).map((item) => {
        this[item] = this.conduitInfo[item]
          ? this.conduitInfo[item]
          : this[item];
      });
    this.curveLineWidth =  this.setPointProportion(this.curveLineWidth).x;
    this.curterWidth =  this.setPointProportion(this.curterWidth).x;
    this.pointsCopy = JSON.parse(JSON.stringify(this.conduitInfo.points));


    this.points.map((item) => {
      item.x = this.setPointProportion(item.x, item.y).x;
      item.y = this.setPointProportion(item.x, item.y).y;
    });
    this.setCanvas();
  },
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
</style>
